import { render, staticRenderFns } from "./CorporationBackground.vue?vue&type=template&id=f86858b2&"
import script from "./CorporationBackground.vue?vue&type=script&lang=js&"
export * from "./CorporationBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports